import React from "react";
import {KHExtension} from "../../services/KHExtensionsService";

export type RenderFunction = (schema: KHExtension<"component">) => React.ReactNode;

export class KHExtensionsRuntime {
    private readonly _renderers: Map<string, RenderFunction> = new Map();

    constructor(renderers: Map<string, RenderFunction> = new Map()) {
        this._renderers = renderers;
    }

    addRender(type: string, render: RenderFunction) {
        this._renderers.set(type, render);
    }

    render(schema: KHExtension<"component">): React.ReactNode {
        const render = this._renderers.get(schema.data.render.type);
        if (render) {
            return render(schema);
        } else {
            return (
                <>Not Found!</>
            );
        }
    }
}
